import { useEffect, useState } from 'react'

type UseBrowseLimitArgs = {
  min?: number
  max?: number
}

export default function useBrowseLimit(options?: UseBrowseLimitArgs) {
  const { min = 8, max = 200 } = options || {}

  const [limit, setLimit] = useState<number | null>(null)

  const getNumResultsPerPage = () => {
    const isSmScreen = window.matchMedia('(min-width: 640px)').matches
    const isMdScreen = window.matchMedia('(min-width: 768px)').matches
    const isXlScreen = window.matchMedia('(min-width: 1280px)').matches

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight
    const stickyContentHeight = 180 // height of top bar + sticky filters
    const containerMaxVisibleHeight = Math.max(viewportHeight - stickyContentHeight, 0)
    const containerPaddingTop = 48 // padding-top of container
    const availableHeight = containerMaxVisibleHeight - containerPaddingTop

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth
    const sidebarWidth = 256
    const availableWidth = viewportWidth - sidebarWidth

    const xlGridGapX = 32
    const xlMinElementWidth = 240
    const xlContainerPaddingX = 32
    const xlMaxResultsPerRow = Math.floor(
      (availableWidth - xlContainerPaddingX) / (xlMinElementWidth + xlGridGapX)
    )

    const resultsPerRow = isXlScreen ? xlMaxResultsPerRow : isMdScreen ? 3 : 1

    const rowPaddingY = isMdScreen ? 40 : 16
    const minElementHeight = isMdScreen ? 310 : isSmScreen ? 80 : 64
    const minRowHeight = minElementHeight + rowPaddingY

    const minVisibleRows = Math.ceil(availableHeight / minRowHeight)
    const minVisibleResults = minVisibleRows * resultsPerRow

    return minVisibleResults
  }

  useEffect(() => {
    if (limit === null) {
      const numResultsPerPage = Math.max(getNumResultsPerPage(), min)
      setLimit(numResultsPerPage)
    }
  }, [limit, min])

  const getReturnedLimit = () => {
    const limitNum = Number(limit)

    return Math.min(max, Math.max(min, limitNum))
  }

  return {
    enabled: limit !== null,
    limit: getReturnedLimit()
  }
}
